<div
  class="cv-fms"
  [class.cv-fms--emphasis]="emphasis"
  [class.cv-fms--disabled]="disabled"
  [class.cv-fms--open]="isOpen"
>
  <button
    type="button"
    class="cv-fms__trigger"
    [disabled]="disabled || normalizedOptions.length === 0"
    [attr.aria-expanded]="isOpen"
    (click)="togglePanel($event)"
  >
    <div class="cv-fms__trigger-inner">
      <div class="cv-fms__value">
        <ng-container *ngIf="selectedCount === 0">
          <span class="cv-fms__placeholder">{{ placeholder }}</span>
        </ng-container>
        <ng-container *ngIf="selectedCount > 0 && selectedCount <= 2">
          <span class="cv-fms__chip" *ngFor="let v of chipValues">{{ labelForValue(v) }}</span>
        </ng-container>
        <span class="cv-fms__chip cv-fms__chip--count" *ngIf="selectedCount >= 3">
          {{ selectedCount }} selected
        </span>
      </div>
      <div class="cv-fms__trigger-actions">
        <button
          type="button"
          class="cv-fms__clear"
          *ngIf="selectedCount > 0 && !disabled"
          (click)="clear($event)"
          aria-label="Clear selection"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
        <svg
          class="cv-fms__caret"
          [class.cv-fms__caret--open]="isOpen"
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
        >
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </div>
    </div>
  </button>

  <div class="cv-fms__panel" *ngIf="isOpen && normalizedOptions.length > 0" (click)="$event.stopPropagation()">
    <div class="cv-fms__search" *ngIf="showSearch">
      <input
        type="text"
        class="cv-fms__search-input"
        [(ngModel)]="searchTerm"
        placeholder="Search…"
        (click)="$event.stopPropagation()"
      />
    </div>
    <ul class="cv-fms__list" role="listbox">
      <li
        *ngFor="let opt of filteredOptions"
        class="cv-fms__row"
        [class.cv-fms__row--selected]="isSelected(opt.value)"
        (click)="toggleValue(opt.value, $event)"
        role="option"
        [attr.aria-selected]="isSelected(opt.value)"
      >
        <input
          type="checkbox"
          class="cv-fms__checkbox"
          tabindex="-1"
          [checked]="isSelected(opt.value)"
          readonly
        />
        <span class="cv-fms__row-label">{{ opt.label }}</span>
      </li>
      <li *ngIf="filteredOptions.length === 0" class="cv-fms__empty">No matches</li>
    </ul>
  </div>
</div>
